import React, { useState } from "react";
import { Layout, Input, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import authService from "../networks/api/service/authService";

const { Content } = Layout;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const sendOTP = async () => {
    if (!email) {
      message.warning("Please enter email");
      return;
    }

    try {
      setLoading(true);

      const payload = { email };

      const res = await authService.forgotPassword(payload);

      if (res.code === 200) {
        message.success("OTP sent successfully");
        navigate("/verify-password-otp", { state: { email } });
      }
    } catch (error) {
      message.error("Failed to send OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <Content style={{ width: 400, margin: "100px auto" }}>
        <h2>Forgot Password</h2>

        <Input
          placeholder="Enter Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <Button
          type="primary"
          loading={loading}
          style={{ marginTop: 20, width: "100%" }}
          onClick={sendOTP}
        >
          Send OTP
        </Button>
      </Content>
    </Layout>
  );
};

export default ForgotPassword;